import AutoFormCheckbox from "./fields/checkbox"
import AutoFormDate from "./fields/date"
import AutoFormEnum from "./fields/enum"
import AutoFormExtendedOptions from "./fields/extended-options"
import AutoFormFile from "./fields/file"
import FormattedInput from "./fields/formatted-input"
import GenderRadioGroup from "./fields/gender-radio"
import AutoFormInput from "./fields/input"
import { AutoFormMedalCountConfig } from "./fields/medal-count-config"
import AutoFormNumber from "./fields/number"
import AutoFormRadioGroup from "./fields/radio-group"
import { AutoFormRangePicker } from "./fields/range-picker"
import AutoFormSwitch from "./fields/switch"
import AutoFormTextarea from "./fields/textarea"
import AutoFormTimePicker from "./fields/time-picker"

export const INPUT_COMPONENTS = {
  checkbox: AutoFormCheckbox,
  date: AutoFormDate,
  select: AutoFormEnum,
  radio: AutoFormRadioGroup,
  switch: AutoFormSwitch,
  textarea: AutoFormTextarea,
  number: AutoFormNumber,
  file: AutoFormFile,
  fallback: AutoFormInput,
  extendedOptions: AutoFormExtendedOptions,
  formattedInput: FormattedInput,
  genderRadio: GenderRadioGroup,
  time: AutoFormTimePicker,
  medalCountConfig: AutoFormMedalCountConfig,
  rangePicker: AutoFormRangePicker,
}

/**
 * Define handlers for specific Zod types.
 * You can expand this object to support more types.
 */
export const DEFAULT_ZOD_HANDLERS: {
  [key: string]: keyof typeof INPUT_COMPONENTS
} = {
  ZodBoolean: "checkbox",
  ZodDate: "date",
  ZodEnum: "select",
  ZodNativeEnum: "select",
  ZodNumber: "number",
}
